import { useLang } from "@/context/LanguageContext";
import { boxingTotals, labelCounts } from "@/lib/boxing";
import Meter, { percentOf } from "./Meter";

const LEGEND = [
  ["#f59e0b", "recv.dims_needed"],
  ["#60a5fa", "recv.dims_set"],
  ["#34d399", "recv.box_ready"],
];

// Progress strip above the stores: units boxed while packing, boxes labelled once boxing is over.
export default function BoxingSummary({ stores, boxes, labelMode }) {
  const { t } = useLang();

  if (labelMode) {
    const counts = labelCounts(boxes);
    const share = (value) => percentOf(value, boxes.length);
    return (
      <div className="rounded-xl border border-slate-200 bg-white px-4 py-3">
        <div className="mb-1.5 flex items-baseline justify-between gap-2.5">
          <b className="text-base">{t("recv.sum_labelled", { applied: counts.APPLIED, count: boxes.length })}</b>
          <span className="text-sm text-slate-500">{t("recv.box_count", { count: boxes.length })}</span>
        </div>
        <Meter segments={[
          { percent: share(counts.APPLIED), color: "#10b981" },
          { percent: share(counts.READY), color: "#60a5fa" },
        ]} />
      </div>
    );
  }

  const totals = boxingTotals(stores, boxes);
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 rounded-xl border border-slate-200 bg-white px-4 py-3">
      <div className="min-w-60 flex-1">
        <b className="mb-1.5 block text-base">{t("recv.sum_units", { boxed: totals.boxed, planned: totals.planned })}</b>
        <Meter segments={[{ percent: percentOf(totals.boxed, totals.planned), color: "#2563eb" }]} />
      </div>
      {[[totals.boxCount, "recv.sum_boxes_opened"], [totals.readyCount, "recv.sum_boxes_ready"]].map(([value, key]) => (
        <div key={key}>
          <b className="block text-xl leading-tight">{value}</b>
          <span className="text-xs text-slate-500">{t(key)}</span>
        </div>
      ))}
      <div className="flex w-full flex-wrap gap-3 text-xs text-slate-500">
        {LEGEND.map(([color, key]) => (
          <span key={key} className="flex items-center gap-1.5">
            <i className="inline-block h-2.5 w-2.5 rounded-sm" style={{ backgroundColor: color }} />{t(key)}
          </span>
        ))}
      </div>
    </div>
  );
}
